import React from "react";
import moment from "moment";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import * as Dati from "../../../Dati";
import * as Glob from "../../../Globale";
import { Trad } from "../../../components/";
import { _Autocomplete, _DateField, _NumberField, _Select } from "../../form";

interface IExposureLimitApprovalsProps {
    Data: Glob.DatiJSON;
    Name: string;
    Types: Dati.TDictTipo;
    OnChange: (e: React.FormEvent<any> | string, val?: unknown) => void;
}

const useStyles = makeStyles(({ spacing }: Theme) => ({
    subtitle: {
        width: "100%",
        paddingLeft: spacing(2),
        marginTop: spacing(4)
    }
}));

export const _ExposureLimitApprovals: React.FC<IExposureLimitApprovalsProps> = ({ Data, Name, Types, OnChange }) => {
    const classes = useStyles();

    const data: Dati.CFideAffidamentoApprovazione[] = JSON.parse(Data);
    const session = Glob.GetSessione();

    const onApprovalChange = (index: number): void => {
        data[index].Data = new Date(Date.now());

        OnChange(Name, JSON.stringify(data));
    };

    return (
        <>
            {data.map((item, index) => (
                <Grid container spacing={4} key={item.ID_AnagDa}>
                    <Typography className={classes.subtitle} variant="subtitle2">
                        {Trad.Trad("ApprovazioneAffidamento")}
                    </Typography>

                    <Grid item xs={12} md={4}>
                        <_Autocomplete Value={item.ID_AnagDa ?? ""} Name="ID_AnagDa" Label="" OnChange={OnChange} Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Disabled />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <_Select
                            Value={item.ID_TipoFideAffidamentoApprovazione || Glob.Tipi_FAA_Proposta}
                            Name="ID_TipoFideAffidamentoApprovazione"
                            Label=""
                            Disabled={session.ID_Anag != item.ID_AnagDa}
                            OnChange={(id, val) => {
                                data[index][id] = val || Glob.Tipi_FAA_Proposta;
                                onApprovalChange(index);
                            }}
                            Options={Types ?? {}}
                        />
                    </Grid>
                    <Grid item xs={6} md={1}>
                        {moment(item.Data).format(Trad.Trad("DD/MM/YYYY"))}
                    </Grid>
                    {Glob.AzioneAbilitata("FideAffidamentoApprovazioneCommenti", Glob.Lettura) &&
                        Object.keys(item.CommentiGruppi).map(key => (
                            <Grid item xs={12} key={key}>
                                <TextField
                                    multiline
                                    fullWidth
                                    variant="outlined"
                                    id={`CommentiGruppi.${key}`}
                                    label={`${Trad.Trad("Commenti")} ${Trad.Trad("Gruppo" + key)}`}
                                    rows={3}
                                    rowsMax={5}
                                    value={item.CommentiGruppi[key]}
                                    onChange={e => {
                                        data[index]["CommentiGruppi"][key] = e.currentTarget.value;
                                        onApprovalChange(index);
                                    }}
                                    disabled={session.ID_Anag != item.ID_AnagDa || session.Gruppi.indexOf(key) < 0}
                                />
                            </Grid>
                        ))}
                </Grid>
            ))}
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/ExposureLimit/ExposureLimitApprovals.tsx